<template>
    <card>
       <template slot="header">
          <h3 class="card-title">WFH Responsibility Details</h3>
       </template>
       <div class="row">
          <nav>
             <ol class="breadcrumb arr-right bg-breadcrum">
                <li class="breadcrumb-item">
                   <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/hr/wfh/responsibility">Office Responsibility</router-link>
                 </li>
                 
                 <li class="breadcrumb-item active">WFH Responsibility Details</li>
             </ol>
          </nav>
       </div>
       <hr style="margin-top:-10px"/>
       <br/>
       <div class="report-container-wfh">
         <div class="report-border-wfh">
           <center> 
               <img class="logo-print" width="190" height="110" src="/static/img/blueprintlogo.png" alt="..."/>
               <h4><b>BLUEPRINT   BUSINESS   SOLUTION   BPO   CORP</b></h4>
               <h5 style="margin-top:-8px"><b>ADDENDUM   OF   AFFIDAVIT   OF   UNDERTAKING </b></h5>
            </center>
            <br/>
            <p>Due to the extension of the Enhanced Community Quarantine mandated by the local government of
               Lapulapu City, that I, upon my request to Temporarily Work from Home until April 28, 2020, I agree to
               be compliant to all the terms indicated in this affidavit as well as my employment contract with the
               company.
              </p>

            <p>
                Extension of the Work from Home (fulltime) is dependent upon the mandate of the local government
                of Lapulapu City. Once lifted I agree to go back fulltime, officebased. Failure to do so will result in
                Breach of Contract thus endorsement for a legal case.
            </p>
           <p>
               All the other rules and regulations as well as guidelines stated in my Employment Contract and the
               Affidavit of Undertaking will still apply and is considered valid.
            </p>

            <p>
                <div class="row">
                    <div class="col-md-2">
                     </div>
                     <div class="col-md-10">
                           <b> 1.</b> That I must be compliant to all terms and conditions stated in the signed and completed
                            Blueprint Business Solution BPO Corp Employment Agreement upon hire date. With the
                            Temporary Work from Home Program of the company upon my request in full reiteration
                            and emphasis of the Confidentiality Clause in the contract.
                     </div>    
                </div>    
            </p>
            <p>
                <div class="row">
                        <div class="col-md-2">
                            </div>
                            <div class="col-md-10">
                              <b>  2.</b> Two instances of unresponsiveness during work hours will result in revocation of the
                                Work from Home scheme where in the Blueprint PC unit will be pulled out and the agent is
                                expected to be back to IN OFFICE status.
                            </div>    
                    </div>  
            </p>
            <br/> 
             <p>
                <b>CONFORME:</b><br/>
                I accept the terms of this letter. I understand that the benefits, policies, and procedures of the
                Company are subject to future updates and/or changes, and that my employment is contingent upon
                the conditions set forth in this letter.
            </p>
              <br/> <br/> <br/> <br/> <br/>
            
              <!-- SIGNATURE-SECTION -->    
                <div class="row">
                     <div class="col-md-5">
                        <br/><br/>
                         <div class="report-signature-container">    
                            <img class="report-signature-control"  :src="responsibilityItem.wfh_signature" alt="..."/>
                            <div class="report-printed-control"><b> {{responsibilityItem.full_name | uppercase}}</b></div>
                         </div>   
                         <div class="report-line-divider"></div>
                         <center>Signature over Printed Name</center> 
                    </div>
                    <div class="col-md-3"></div>
                    <div class="col-md-4">
                        <br/>
                          <center> {{responsibilityItem.date_sign}} </center>
                           <div class="report-line-divider"></div>
                           <center>Date Signed </center> 
                    </div>
                </div>
                <br/>
                <br/>
                <br/>
            <!--END SIGNATURE SECTION -->
            </div>   
            </div>
            <br/>  <br/>  <br/>
        </div>
    </div>
    </card>
 </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
import { IntegerPlusminus } from 'vue-integer-plusminus'
export default {
components: {
    Card
},
data(){
   return {
       responsibilityItem:{}
   }
},
created:function(){
      this.fetchItem()
},
methods:{
 
   fetchItem() {
        axios.get('api/wfh/responsibility/hr/get/' + this.$route.params.id)
        .then(resp => {
            this.responsibilityItem = resp.data;
            console.log('response =>', this.responsibilityItem);

        })
        .catch(error => {
            console.log(error)
        });
    },

},

}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-responsibility-form/todo-view-wfh-responsibility.vue